import budgetApi from '../../../service/modules/budget.api';


// =========================================================================

/**
 * Busca um orçamento específico por ID
 * 
 * @param {string} budgetId - ID do orçamento
 * @returns {Promise<Object>} Dados do orçamento
 */
export const fetchBudgetById = async (budgetId) => {
  try {
    
    const response = await budgetApi.getById(budgetId);


    return { 
      success: true,
      data: response.data?.data,
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao buscar orçamento ${budgetId}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

 


export const fetchBudgetGetAll = async (user) => {
  try {
  
    const idUser = user?.uid || '';
    const response = await budgetApi.getAll({ idUser });
    const budgets = Array.isArray(response?.data?.data) ? response.data.data : [];

    
    return {
      success: true,
      data: budgets,
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao buscar orçamento {}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};



//
/**
 * Cria um novo orçamento
 * 
 * @param {Object} budgetData - Dados do orçamento
 * @returns {Promise<Object>} Orçamento criado
 */
export const createBudget = async (budgetData) => {
  try {
    // Validações
    if (!budgetData.clientPayment?.name) {
      throw new Error('Nome do cliente é obrigatório');    
    }
    if (!budgetData.clientPayment?.cnpj) {
      throw new Error('CNPJ do cliente é obrigatório');
    }
    if (!Array.isArray(budgetData.stopping_points) || budgetData.stopping_points.length < 1) {
      throw new Error('É necessário pelo menos um ponto de parada');
    }

    // Conversão de tipos
    const payload = {
      ...budgetData,
      numberSerial: parseInt(budgetData.numberSerial, 10),
      summary: {
        ...budgetData.summary,
        weightCargo: parseFloat(budgetData.summary.weightCargo) || 0,
        valueNF: parseFloat(budgetData.summary.valueNF) || 0,
        valueFreightage: parseFloat(budgetData.summary.valueFreightage) || 0,
        additionalStops: parseInt(budgetData.summary.additionalStops, 10) || 0,
      },
      firstDelivery: {
        ...budgetData.firstDelivery,
        coordinates: {
          latitude: parseFloat(budgetData.firstDelivery.coordinates.latitude) || 0,
          longitude: parseFloat(budgetData.firstDelivery.coordinates.longitude) || 0,
        },
      },
      lastDelivery: {
        ...budgetData.lastDelivery,
        coordinates: {
          latitude: parseFloat(budgetData.lastDelivery.coordinates.latitude) || 0,
          longitude: parseFloat(budgetData.lastDelivery.coordinates.longitude) || 0,
        },
      },
    };

    //manda para o back
    
    const response = await budgetApi.create(payload);


   
    return {
      success: true,
      data: response.data?.data,  //volta do back
      message: 'Orçamento criado com sucesso!',
    };
  } catch (error) {
    console.error('❌ [ACTION] Erro ao criar orçamento:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

// =====================================================================

/**
 * Atualiza um orçamento existente
 * 
 * @param {string} budgetId - ID do orçamento
 * @param {Object} budgetData - Dados atualizados
 * @returns {Promise<Object>} Orçamento atualizado
 */
export const updateBudget = async (budgetId, budgetData) => {
  try {
    // Conversão de tipos
    const payload = {
      ...budgetData,
      numberSerial: parseInt(budgetData.numberSerial, 10),
      summary: {
        ...budgetData.summary,
        weightCargo: parseFloat(budgetData.summary.weightCargo) || 0,
        valueNF: parseFloat(budgetData.summary.valueNF) || 0,
        valueFreightage: parseFloat(budgetData.summary.valueFreightage) || 0,
        additionalStops: parseInt(budgetData.summary.additionalStops, 10) || 0,
      },
      firstDelivery: {
        ...budgetData.firstDelivery,
        coordinates: {
          latitude: parseFloat(budgetData.firstDelivery.coordinates.latitude) || 0,
          longitude: parseFloat(budgetData.firstDelivery.coordinates.longitude) || 0,
        },
      },
      lastDelivery: {
        ...budgetData.lastDelivery,
        coordinates: {
          latitude: parseFloat(budgetData.lastDelivery.coordinates.latitude) || 0,
          longitude: parseFloat(budgetData.lastDelivery.coordinates.longitude) || 0,
        },
      },
    };

    
    //id e dados a atualizar
    const response = await budgetApi.update(budgetId, payload);

    
    return {
      success: true,
      data: response.data?.data,
      message: 'Orçamento atualizado com sucesso!',
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao atualizar orçamento ${budgetId}:`, error);
    return {
      success: false,
      //duas ? falhou cai ||
      error: error.response?.data?.message || error.message,
      data: null,
    };
  }
};


// 
/**
 * Deleta um orçamento
 * 
 * @param {string} budgetId - ID do orçamento a deletar
 * @returns {Promise<Object>} Resultado da operação
 */
export const deleteBudgetById = async (budgetId) => {
  try {
   
    await budgetApi.delete(budgetId);
    
  
    return {
      success: true,
      message: `Orçamento ${budgetId} deletado com sucesso!`,
    };
  } catch (error) {
    console.error(`❌ [ACTION] Erro ao deletar orçamento ${budgetId}:`, error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
};

// ============================================================================
// 📊 BUSCAR ORÇAMENTOS POR STATUS
// ============================================================================

/**
 * Busca orçamentos filtrados por status  
 * @param {string} status - Status do orçamento
 * @returns {Promise<Array>} Lista de orçamentos com esse status
 */
export const fetchBudgetsByStatus = async (status) => {
  try {
    
    const response = await budgetApi.getByStatus(status);
    
    
    return {
      success: true,
      data: response.data || [],
      count: response.data?.length || 0,
    };
  } catch (error) {
    console.error('❌ [ACTION] Erro ao filtrar orçamentos por status:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

// ============================================================================
// 👥 BUSCAR ORÇAMENTOS POR CLIENTE
// ============================================================================

/**
 * Busca orçamentos de um cliente específico
 * @param {string} clientName - Nome do cliente
 * @returns {Promise<Array>} Lista de orçamentos do cliente
 */
export const fetchBudgetsByClient = async (clientName) => {
  try {
    
    const response = await budgetApi.getByClient(clientName);
    
   
    return {
      success: true,
      data: response.data || [],
      count: response.data?.length || 0,
    };
  } catch (error) {
    console.error('❌ [ACTION] Erro ao buscar orçamentos por cliente:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
      data: [],
    };
  }
};

// ============================================================================
// 🔧 UTILITÁRIOS
// ============================================================================

/**
 * Valida dados do orçamento antes de enviar
 * @param {Object} budgetData - Dados a validar
 * @returns {Object} { valid: boolean, errors: string[] }
 */
export const validateBudget = (budgetData) => {
  const errors = [];

  // Cliente
  if (!budgetData.clientPayment?.name) {
    errors.push('Nome do cliente é obrigatório');
  }
  if (!budgetData.clientPayment?.cnpj) {
    errors.push('CNPJ do cliente é obrigatório');
  }

  // Coleta
  if (!budgetData.firstDelivery?.name) {
    errors.push('Local de coleta é obrigatório');
  }
  if (!budgetData.firstDelivery?.dateColeta) {
    errors.push('Data de coleta é obrigatória');
  }

  // Entrega
  if (!budgetData.lastDelivery?.name) {
    errors.push('Local de entrega é obrigatório');
  }
  if (!budgetData.lastDelivery?.dateColeta) {
    errors.push('Data de entrega é obrigatória');
  }

  // Serial
  if (!budgetData.numberSerial) {
    errors.push('Número serial é obrigatório');
  }

  // Pontos de parada
  if (!Array.isArray(budgetData.stopping_points) || budgetData.stopping_points.length < 1) {
    errors.push('É necessário pelo menos um ponto de parada');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

/**
 * Formata dados do orçamento para exibição
 * @param {Object} budget - Orçamento
 * @returns {Object} Orçamento formatado
 */
export const formatBudgetForDisplay = (budget) => {
  return {
    ...budget,
    createDataFormatted: budget.createData ? new Date(budget.createData).toLocaleDateString() : '-',
    statusFormatted: budget.status?.describe || '-',
    clientName: budget.clientPayment?.name || '-',
    firstDeliveryName: budget.firstDelivery?.name || '-',
    lastDeliveryName: budget.lastDelivery?.name || '-',
  };
};

/**
 * Prepara dados do orçamento para edição
 * 
 * @param {Object} budget - Orçamento
 * @returns {Object} Orçamento pronto para editar
 */
export const prepareBudgetForEdit = (budget) => {
  return {
    ...budget,
    // Garantir que os valores numéricos sejam strings para o formulário
    numberSerial: String(budget.numberSerial || ''),
    summary: {
      ...budget.summary,
      weightCargo: String(budget.summary?.weightCargo || ''),
      valueNF: String(budget.summary?.valueNF || ''),
      valueFreightage: String(budget.summary?.valueFreightage || ''),
      additionalStops: String(budget.summary?.additionalStops || ''),
    },
    firstDelivery: {
      ...budget.firstDelivery,
      coordinates: {
        latitude: String(budget.firstDelivery?.coordinates?.latitude || ''),
        longitude: String(budget.firstDelivery?.coordinates?.longitude || ''),
      },
    },
    lastDelivery: {
      ...budget.lastDelivery,
      coordinates: {
        latitude: String(budget.lastDelivery?.coordinates?.latitude || ''),
        longitude: String(budget.lastDelivery?.coordinates?.longitude || ''),
      },
    },
  };
};
